import React from 'react';
import HelpBubble from 'js/components/help_bubble';
import {Icon} from '@social-native/snclient-ui';

export const AnalyticsCard = (props) => { 

    const icon = props.icon.startsWith('http') ? (
        // this is to support the legacy use of the component, where the icon is an image.
        <div className="analytics-card-icon-image" style={{ backgroundImage: `url(${props.icon})` }} />
    ) : (
        <i>
            <Icon icon={props.icon} className="analytics-card-icon fa" />
        </i>
    );

    const data =
        props.isSalesUser && props.brandId !== 22 ? (
            <i className="analytics-card-value fa fa-lock" />
        ) : (
            <p className="analytics-card-value">{props.data}</p>
        );

    const helpText = props.helpText ? (
        <HelpBubble
            text={props.helpText}
            multiline={props.multiline}
            place={props.place}
            inline={props.inline}
            tooltipColor={props.tooltipColor}
        />
    ) : null;

    return (
        <li className="analytics-card">
            <div className="analytics-card-title-wrapper">
                <p>{props.label}</p>
                {helpText}
            </div>
            
            {data}

            <div className="analytics-card-icon-wrapper"> 
                {icon}
            </div>
        </li>
    );
};


// WEBPACK FOOTER //
// ./common/campaign_analytics_helper.js